import { isArray, isEmpty } from 'lodash'

interface PaginationFormat<T> {
  content: T[]
  first: boolean
  last: boolean
  number: number
  numberOfElements: number
  totalElements: number
  totalPages: number
}

export const transformArrayToPaginationFormat = <T>(payload: T[] | any): PaginationFormat<T> | any => {
  if (isArray(payload)) {
    return {
      content: payload,
      first: true,
      last: true,
      number: 0,
      numberOfElements: payload.length,
      totalElements: payload.length,
      totalPages: 1,
    }
  }

  return payload
}

export const isOwnReducerAction = (entityKey: string, entities: Record<string, any> | null | undefined): boolean =>
  !(!entities || !entities.hasOwnProperty(entityKey) || isEmpty(entities[entityKey]))

export const isOwnRemoveReducerAction = (entityKey: string, keys: { entity?: string } | null | undefined): boolean =>
  !(!keys || keys.entity !== entityKey)

export const isOwnListReducerAction = (
  ownKey: string,
  entityKey: string | null | undefined,
  listKey: string | null | undefined,
): boolean => !(!entityKey || !listKey || (entityKey && ownKey !== entityKey))
